export const MAX_RULES = 5000;
